export var ReportsGTMConstants;
(function (ReportsGTMConstants) {
    ReportsGTMConstants["NewReports"] = "New Reports";
    ReportsGTMConstants["Holding"] = "Holding";
    ReportsGTMConstants["Positions"] = "Positions";
    ReportsGTMConstants["PNL"] = "Profit & Loss";
    ReportsGTMConstants["Tax"] = "Tax";
    ReportsGTMConstants["All"] = "All";
    ReportsGTMConstants["SummarizeValues"] = "Summarize Values";
    ReportsGTMConstants["Equity"] = "Equity";
    ReportsGTMConstants["Allqty"] = "All Quantity";
    ReportsGTMConstants["TrdQty"] = "Tradable Quantity";
    ReportsGTMConstants["FnO"] = "FnO";
    ReportsGTMConstants["TapPledge"] = "Tap to Pledge";
    ReportsGTMConstants["TapAuth"] = "Tap to Authorize";
    ReportsGTMConstants["Authorize"] = "Authorize";
    ReportsGTMConstants["Pledge"] = "Pledge";
    ReportsGTMConstants["Currency"] = "Currency";
    ReportsGTMConstants["Download"] = "Download";
    ReportsGTMConstants["Email"] = "Email";
    ReportsGTMConstants["Search"] = "Search";
    ReportsGTMConstants["FixedIncome"] = "Fixed Income";
    ReportsGTMConstants["Deratives"] = "Deratives";
    ReportsGTMConstants["ManagedPortfolios"] = "Managed Portfolios";
    ReportsGTMConstants["Others"] = "Others";
    ReportsGTMConstants["Commodity"] = "Commodity";
    ReportsGTMConstants["RealEstate"] = "Real Estate";
    ReportsGTMConstants["Submit"] = "Submit";
    ReportsGTMConstants["Enable"] = "Enable";
    ReportsGTMConstants["Disable"] = "Disable";
    ReportsGTMConstants["OrderIcon"] = "Order Icon";
    ReportsGTMConstants["FilterIcon"] = "Filter Icon";
    ReportsGTMConstants["Apply"] = "Apply";
    ReportsGTMConstants["ClosedPositions"] = "Closed positions";
    ReportsGTMConstants["SqOff"] = "Square Off";
    ReportsGTMConstants["SqOffSelPos"] = "Square Off Selected Positions";
    ReportsGTMConstants["PDF"] = "PDF";
    ReportsGTMConstants["EXCEL"] = "EXCEL";
    ReportsGTMConstants["ViewTxnDetails"] = "View Txn Details";
    ReportsGTMConstants["DwnldTxnDetails"] = "Download Txn Details";
    ReportsGTMConstants["Report"] = "Report";
})(ReportsGTMConstants || (ReportsGTMConstants = {}));
